<template>
    <div class="account">
        <!-- <div class="msg">账号密码登录</div> -->
        <div class="form">
            <div>
                <input
                    type="text"
                    class="account"
                    placeholder="请输入昵称"
                    v-model="form.username"
                />
            </div>
            <div>
                <input
                    type="text"
                    class="password"
                    placeholder="密码"
                    v-model="form.password"
                    @keyup.enter="submit"
                />
            </div>
        </div>
        <el-button type="primary" class="btn" :loading="btnLoading" @click="submit">登录</el-button>
        <div class="sb">
            <span @click="$router.push('/login/register')">注册账户</span>
            <span @click="$router.push('/login/forgetPassword')">忘记密码</span>
        </div>
    </div>
</template>

<script>
import {pwdLogin} from '@/api/login'
import {getInfo} from '@/api/home.js'

export default {
    name: "pcLogin",
    data() {
        return {
            form: {
                // username: "hxl",
                // password: "123456",
                username: "",
                password: "",
            },
            
            btnLoading: false,
        };
    },
    methods: {
        submit() {
            
            // 防止重复点击
            if (this.btnLoading) return;
            
            const { username, password } = this.form;
            if (!username) return this.$message.error('请输入昵称或邮箱');
            if (!password) return this.$message.error('请输入密码');
            
            this.btnLoading = true
            
             pwdLogin(this.form).then(async res => {
                if (res.code === 200) {
                    this.$vuex("vuex_token", res.data.token);
                    let userInfo = await getInfo();
                    this.$vuex("vuex_userInfo", userInfo.data.user);
                    
                    this.$message({message: "登录成功", type: "success"});
                    await this.$router.replace("/");
                } else {
                    this.$message({message: res.msg, type: "warning"});
                }
            }).finally(() => {
                this.btnLoading = false
            })
        },
    },
};
</script>


<style lang="scss" scoped>
.account {
    .msg {
        text-align: center;
        margin: 30px 0;
        font-size: 28px;
    }
    
    .form {
        width: 80%;
        margin: auto;
        
        div {
            border: 1px solid rgba(0, 0, 0, 0.1);
            margin-bottom: 20px;
            
            input {
                width: 100%;
                height: 40px;
                margin: 0;
                border: 0;
                padding: 0 0 0 40px;
                box-sizing: border-box;
                outline: none;
                border-radius: 5px;
                background-repeat: no-repeat;
                background-position: 10px center;
                background-size: 20px;
                
                &.account {
                    background-image: url("@/assets/login/account.png");
                }
                
                &.password {
                    background-image: url("@/assets/login/pass.png");
                }
            }
        }
    }
    
    .btn {
        display: block;
        cursor: pointer;
        padding: 14px 0 !important;
        width: 80%;
        margin: auto;
        background-color: #256dbc;
        text-align: center;
        border-radius: 5px;
        box-sizing: border-box;
        color: #ffffff;
    }
    
    .sb {
        width: 80%;
        margin: 15px auto;
        display: flex;
        justify-content: space-between;
        color: #256dbc;
        
        span {
            cursor: pointer;
        }
    }
}
</style>
